import { useState } from "react";
import { SelectSlots } from "./select-slots";
import { AppliedPostsView } from "../AppliedPosts";
import { convertDateToIST } from "src/lib/utils";
import { useFetchAllSlotDates } from "src/redux/api/hooks/useFetchAllSlotDates";

export const SelectSlotView = () => {
  return <div>select view</div>;
};
